/**
 * 涉及到组件【not-seat-list，d_juyuan,d_yuan】
 *  拖拽分两种模式
 *  一 为分配模式（从not-seat-list.vue组件中拖放到d_juyuan与d_yuan）
 *  二 为交换模式（多个区域或者单个区域交换模式）【d_juyuan与d_yuan】
 */

import { mapState } from 'vuex';
/************** 分配模式数据 **************/
// 分配的人
var personInfo = null 
/************** 交换模式数据 **************/
// 拖拽的索引
var temp_layout_index=0,
    temp_row_index=0,
    temp_col_index=0,
    temp_seat_index=0,
    temp_seat_valid=1; // 当前拖入的是否为有效的座位
// 拖拽到目标的索引
var temp_layout_index_ing=0,
    temp_row_index_ing=0,
    temp_col_index_ing=0,
    temp_seat_index_ing=0,
    temp_seat_valid_ing=1; // 当前拖入的是否为有效的座位
/************** 交换模式数据 **************/
export default {
    components:{
    },
    props: {
        // 是否为预览模式
        isPreview:{
            type:Boolean,
            default:false,
        }
    },
    data() {
        return {
        }
    },
    computed:{
        ...mapState(['layoutData'])
    },
    methods: {

        /** 以下是拖拽排序的事件 */
        handleDragStart(e) {
            // 预览模式不可编辑
            if(this.isPreview){ return false; }

            // 以下为交换模式数据
            if(e.target){
                temp_layout_index = e.target.getAttribute('layout-index');
                temp_row_index = e.target.getAttribute('row-index');
                temp_col_index = e.target.getAttribute('col-index');
                temp_seat_index = e.target.getAttribute('seat-index');
                temp_seat_valid = e.target.getAttribute('is-valid');
            // 以下为分配模式的数据
            }else{
                personInfo = e;
            }
        },
        handleDragEnd(e) {
            // 预览模式 或 拖入非有效座位 或 非有效区域也不可交换 不可编辑
            if(this.isPreview || temp_seat_valid_ing == 0 || temp_seat_valid == 0){ return false; }
            
            let layoutData = JSON.parse(JSON.stringify(this.layoutData));
            
            /************** 分配模式处理 **************/
            if(temp_layout_index_ing && temp_row_index_ing && temp_col_index_ing && temp_seat_index_ing){
                if(personInfo){
                    // 获取交换请求参数
                    let reqParams = this.getReqParams(layoutData);
                    let params = {
                        layout_id:reqParams.u_layout_id,
                        row_id:reqParams.u_row_id,
                        desk_id:reqParams.u_desk_id,
                        seat_id:reqParams.u_seat_id,
                        user_id:personInfo.id,
                        is_seat:1
                    }
                    this.$request.post({url:'saveUserSeatLayout',data:params}).then(res => {
                        try{
                            layoutData[temp_layout_index_ing].seat_list[temp_row_index_ing].col[temp_col_index_ing].seat_item[temp_seat_index_ing].person = {
                                company: personInfo.company,
                                name: personInfo.name,
                                person_id:personInfo.id,
                                sex:personInfo.sex,
                            }
                            // 更新vuex的数据
                            this.$store.commit('updateState',{layoutData})
                        }catch{
                            this.$store.dispatch('getLayoutData').then();
                        }
                        // 获取删除人的索引
                        let index = this.notSeatPersonList.findItem({id:params.user_id},false);
                        // 删除当前人
                        this.notSeatPersonList.splice(index,1);
                        // 更新notSeatPersonList的数据
                        this.$store.commit('updateState',{notSeatPersonList:this.notSeatPersonList});
    
                        // 更新leftLayoutData
                        this.$store.dispatch('getLayoutSeatUser').then();
    
                        // 清空参数
                        this.resetParams();
                    })
                    
                /************** 交换模式处理 **************/
                }else{
                    // 当前拖动的元素
                    let currDragItem = layoutData[temp_layout_index]?.seat_list[temp_row_index]?.col[temp_col_index]?.seat_item[temp_seat_index]?.person;
                    // 拖动的目标元素
                    let targetDragItem = layoutData[temp_layout_index_ing]?.seat_list[temp_row_index_ing]?.col[temp_col_index_ing]?.seat_item[temp_seat_index_ing]?.person;
    
                    // 都不存在或者用户ID相同则无需交换
                    if ((!currDragItem && !targetDragItem) || (currDragItem?.person_id == targetDragItem?.person_id)) {
                        return;
                    }
    
                    // 再次copy当前交换的两条数据
                    let copyCurrDragItem = JSON.parse(JSON.stringify(currDragItem));
                    let copyTargetDragItem = JSON.parse(JSON.stringify(targetDragItem));
    
                    // 获取交换请求参数
                    let reqParams = this.getReqParams(layoutData);
    
                    this.$request.post({url:"updateLayout",data:reqParams}).then(res => {
                        // 本地数据交换
                        layoutData[temp_layout_index].seat_list[temp_row_index].col[temp_col_index].seat_item[temp_seat_index].person = copyTargetDragItem;
                        layoutData[temp_layout_index_ing].seat_list[temp_row_index_ing].col[temp_col_index_ing].seat_item[temp_seat_index_ing].person = copyCurrDragItem;
                        
                        // 更新vuex的数据
                        this.$store.commit('updateState',{layoutData})
    
                        // 更新leftLayoutData
                        this.$store.dispatch('getLayoutSeatUser').then();
    
                        // 清空参数
                        this.resetParams();
                    })
                }
            }
            
        },
        handleDragOver(e) {
            // 预览模式不可编辑
            if(this.isPreview){ return false; }
            
            // 首先把div变成可以放置的元素，即重写dragenter/dragover
            // 在dragenter中针对放置目标来设置
            e.dataTransfer.dropEffect = "move";
        },
        handleDragEnter(e) {
            // 预览模式不可编辑
            if(this.isPreview){ return false; }
            if(e.srcElement){
                temp_layout_index_ing = e.srcElement.getAttribute('layout-index');
                temp_row_index_ing = e.srcElement.getAttribute('row-index');
                temp_col_index_ing = e.srcElement.getAttribute('col-index');
                temp_seat_index_ing = e.srcElement.getAttribute('seat-index');
                // 当前拖入的是否为有效的座位
                temp_seat_valid_ing = e.srcElement.getAttribute('is-valid');
                // 为需要移动的元素设置dragstart事件
                e.dataTransfer.effectAllowed = "move";
            }
        },
        /** 以上是拖拽排序的事件 */

        // 清空参数
        resetParams(){
            this.$nextTick(() => {
                // 清空数据
                temp_layout_index = 0;
                temp_row_index = 0;
                temp_col_index = 0;
                temp_seat_index = 0;
                temp_seat_valid = 1;

                temp_layout_index_ing = 0;
                temp_row_index_ing = 0;
                temp_col_index_ing = 0;
                temp_seat_index_ing = 0;
                temp_seat_valid_ing = 1;

                personInfo = null;
            });
        },

        // 获取请求参数
        getReqParams(layoutData){
            // 拖拽的元素
            let areaItem = layoutData[temp_layout_index];
            let { area_id } = areaItem;
            let rowItem = areaItem.seat_list[temp_row_index];
            let { row_id } = rowItem;
            let colItem = rowItem.col[temp_col_index];
            let { desk_id } = colItem;
            let seatItem = colItem.seat_item[temp_seat_index];
            let { seat_id } = seatItem;
            let person_id = seatItem.person?.person_id;

            // 目标元素
            areaItem = layoutData[temp_layout_index_ing];
            let { area_id:u_area_id } = areaItem;
            rowItem = areaItem.seat_list[temp_row_index_ing];
            let { row_id:u_row_id } = rowItem;
            colItem = rowItem.col[temp_col_index_ing];
            let { desk_id:u_desk_id } = colItem;
            seatItem = colItem.seat_item[temp_seat_index_ing];
            let { seat_id:u_seat_id } = seatItem;
            let u_person_id = seatItem.person?.person_id;

            return {
                area_id,
                row_id,
                desk_id,
                seat_id,
                person_id,
                u_area_id,
                u_layout_id:u_area_id,
                u_row_id,
                u_desk_id,
                u_seat_id,
                u_person_id,
            }
        },
    }
}